import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";

const schema = yup.object({
  new_todo: yup.string().required("O campo é obrigatório!")
}).required();

export { schema, yupResolver };